import React, { useEffect, useState, useRef } from "react";
import {
  Link,
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Space,
  Select,
  DatePicker,
  Table,
  Tooltip,
  Input,
  Col,
  Form,
  Popconfirm,
  Modal,
  Button,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import ExelDownload from "../../image/exeldownload.svg";
import {
  EyeOutlined,
  DownloadOutlined,
  FileExcelOutlined,
  UndoOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import SearchIcon from "../../image/SearchIcon.svg";
import RefreshIcon from "../../image/refreshIcon.svg";
import { getRequest, patchRequest, postRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
  WarningNotificationMsg,
} from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";
import { confirmAlert } from "react-confirm-alert";
import moment from "moment";
import { debounce, toLower } from "lodash";
import axios from "axios";
import "jspdf-autotable";
import jsPDF from "jspdf";
import Floating from "../../image/floating.svg";
import * as XLSX from "xlsx";
import SubscriptionNotification from "../../authentication/SubscriptionNotification";
const { Search } = Input;

const AssignPurchaseRequisition = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const formRef = useRef();
  const [form] = Form.useForm();
  const handleSelectChange = (value) => {
    setPRStatus(value);
  };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const { id } = useParams();
  const CategoryId = id;

  const { state: details } = useLocation();

  // const { categoryId, selectedCategoryName } = details;

  let categoryId, selectedCategoryName;

  if (details) {
    ({ categoryId, selectedCategoryName } = details);
  }

  const [
    purchaseRequisitionFloatRFQAssignPR,
    setPurchaseRequisitionFloatRFQAssignPR,
  ] = useState([]);

  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [selectedRow, setSelectedRow] = useState([]);

  // const employee = authUserData()?.company
  //   ? authUserData()?.role?.includes("company_")
  //   : null;

  const roles = authUserData()?.role || [];
  const employee = roles.some((role) => role.name.includes("company_"));

  console.log("employee66 ", employee);

  const employeeID = authUserData()?.employee ? authUserData()?.employee : null;
  const companyUserId = authUserData()?.company
    ? authUserData()?.user_id
    : null;
  const companyUserName = authUserData()?.company
    ? authUserData()?.first_name
    : null;
  const [btnLoading, setBtnLoading] = useState(false);
  const [assignToBuyer, setAssignTobuyer] = useState(false);
  const [reload, setReload] = useState(false);
  const [assignBuyer, setAssignBuyer] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [prStatus, setPRStatus] = useState("");
  const [totalCount, settotalCount] = useState(0);
  const [zoneList, setZoneList] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [clickedFilterButton, setClickedFilterButton] = useState(false);
  const selectRef = useRef(null);
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
  });
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const handleReset = () => {
    setClickedFilterButton(false);
    setPRStatus("");
    setStartDate("");
    setEndDate("");

    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
    });
    formRef.current.setFieldsValue({
      pr_created_date__gte: null,
      pr_status: null,
      pr_created_date__lte: null,
    });
  };
  const handleClearFields = () => {
    setStartDate("");
    setEndDate("");
  };
  const handleRefresh = async () => {
    setStartDate("");
    setEndDate("");
    formRef.current.setFieldsValue({
      pr_created_date__lte: null,
      pr_created_date__gte: null,
    });
    form.setFieldsValue({ search: "" });
    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
    });
  };

  const CompanyID = authUserData()?.company ? authUserData()?.company : null;

  const handleStartDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YY");
    setStartDate(formattedDate);
  };

  const handleEndDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YY");
    setEndDate(formattedDate);
  };

  const handleFloat = (selectedRowKeys) => {
    setSelectedRow(selectedRowKeys);
  };

  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const handleFloatRFQ = async (selectedRowIds = []) => {
    if (selectedRowIds.length === 0) {
      WarningNotificationMsg("To proceed, please select and assign at least one PR");
      return;
    }
    if (
      selectedRowIds.some(
        (id) =>
          purchaseRequisitionFloatRFQAssignPR.find((pr) => pr.id === id)
            ?.pr_assign_to_buyer === null
      )
    ) {
      WarningNotificationMsg("Please assign to buyer");
      return;
    }

    try {
      setBtnLoading(true);
      let apiResponse = await postRequest(`float-rfq/`, {
        company: CompanyID,
        category_tree: parseInt(CategoryId),
        purchase_requisition_master: selectedRowIds,
      });

      const responseId = apiResponse.data.data.id;
      navigate(`/request-for-quotation/add-rfq/${responseId}`, {
        state: {
          categoryId: categoryId,
          selectedCategoryName: selectedCategoryName,
        },
      });
    } catch (error) {
      console.error("Error:", error);
      setBtnLoading(false);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleFloatRFQFORApproved = async (selectedRowIds = [], id = "") => {
    let ids = [...selectedRowIds];

    if (id) {
      ids.push(id);
    }
    console.log(ids, "rowsids");
    // let ids = selectedRowIds;
    // if (id) {
    //   ids.push(id);
    // }
    try {
      setBtnLoading(true);
      let apiResponse = await postRequest(`float-rfq/`, {
        company: CompanyID,
        category_tree: parseInt(CategoryId),
        purchase_requisition_master: selectedRowIds,
      });

      const responseId = apiResponse.data.data.id;
      navigate(`/request-for-quotation/add-rfq/${responseId}`, {
        state: {
          categoryId: categoryId,
          selectedCategoryName: selectedCategoryName,
        },
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleFloatRFQFORApprovedDirect = async (
    selectedRowIds = [],
    id = ""
  ) => {
    let ids = selectedRowIds;
    if (id) {
      ids.push(id);
    }
    console.log(selectedRowIds, "iddddd");
    try {
      setBtnLoading(true);
      let apiResponse = await postRequest(`float-rfq/`, {
        company: CompanyID,
        category_tree: parseInt(CategoryId),
        purchase_requisition_master: ids,
      });

      const responseId = apiResponse.data.data.id;
      navigate(`/request-for-quotation/add-rfq/${responseId}`, {
        state: {
          categoryId: categoryId,
          selectedCategoryName: selectedCategoryName,
        },
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const handleFloatRFQFORApprovedDirectActionField = async (
    selectedRowIds = [],
    id = ""
  ) => {
    let ids = selectedRowIds;
    if (id) {
      ids.push(id);
    }
    console.log(selectedRowIds, "iddddd");
    try {
      setBtnLoading(true);
      let apiResponse = await postRequest(`float-rfq/`, {
        company: CompanyID,
        category_tree: parseInt(CategoryId),
        purchase_requisition_master: [ids],
      });

      const responseId = apiResponse.data.data.id;
      navigate(`/request-for-quotation/add-rfq/${responseId}`, {
        state: {
          categoryId: categoryId,
          selectedCategoryName: selectedCategoryName,
        },
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const handleFloatRFQValue = async (value, id, selectedRowIds) => {
    if (selectedRowIds.length === 0) {
      ErrorNotificationMsg("To proceed, please select and assign at least one PR");
      return;
    } else {
      try {
        await patchRequest(`purchase-requisition/${id}/pr-assign-to-buyer/`, {
          pr_assign_to_buyer: value,
        });

        SuccessNotificationMsg(t("pr_assign_to_buyer_successfully"));
        handleFloatRFQFORApproved(selectedRowIds);
        setReload(!reload);
        setLoading(false);
      } catch (error) {
        console.error("Error updating assignee:", error);
      }
    }
  };
  const handleMultipleFloatRFQValueDirect = async (
    value,
    id,
    selectedRowIds,
    name
  ) => {
    console.log(selectedRowIds, "select");
    console.log(id, "select11");

    // try {
    //   await patchRequest(`purchase-requisition/${id}/pr-assign-to-buyer/`, {
    //     pr_assign_to_buyer: value,
    //   });

    //   // SuccessNotificationMsg(t("pr_assign_to_buyer_successfully"));

    //   if (value !== companyUserId) {
    //     let assignedEmployee = assignBuyer.find(
    //       (buyer) => buyer.user_id === value
    //     );
    //     SuccessNotificationMsg(
    //       t(`PR assigned to ${assignedEmployee.first_name} Successfully`)
    //     );
    //   } else {
    //     SuccessNotificationMsg(t(`PR assigned to yourself Successfully`));
    //   }

    //   handleFloatRFQFORApprovedDirect(id);

    //   setReload(!reload);
    //   setLoading(false);
    // } catch (error) {
    //   console.error("Error updating assignee:", error);
    // }
    // let ids = [...selectedRow]; // Use the selected rows
    // if (ids.length === 0 && id) {
    //   ids.push(id); // Add the provided `id` if no rows are selected
    // }
    let ids = selectedRowIds;
    if (id) {
      ids.push(id);
    }
    console.log(ids, "iffff");
    try {
      await patchRequest(`purchase-requisition/multiple-pr-assign-to-buyer/`, {
        pr_assign_to_buyer: value, // Assignee ID
        pr_ids: ids, // Pass multiple IDs as an array
      });
      // Success message handling
      if (value !== companyUserId) {
        let assignedEmployee = assignBuyer.find(
          (buyer) => buyer.user_id === value
        );
        SuccessNotificationMsg(
          t(`PR assigned to ${assignedEmployee.first_name} Successfully`)
        );
      } else {
        SuccessNotificationMsg(t(`PR assigned to yourself Successfully`));
      }

      handleFloatRFQFORApprovedDirect(ids);
      setReload(!reload); // Trigger data reload
      setLoading(false);
    } catch (error) {
      console.error("Error updating assignee:", error);
    }
  };
  const handleFloatRFQValueDirect = async (value, id, selectedRowIds, name) => {
    console.log("valuevcxzc", value, "id", id);

    try {
      await patchRequest(`purchase-requisition/${id}/pr-assign-to-buyer/`, {
        pr_assign_to_buyer: value,
      });

      // SuccessNotificationMsg(t("pr_assign_to_buyer_successfully"));

      if (value !== companyUserId) {
        let assignedEmployee = assignBuyer.find(
          (buyer) => buyer.user_id === value
        );
        SuccessNotificationMsg(
          t(`PR assigned to ${assignedEmployee.first_name} Successfully`)
        );
      } else {
        SuccessNotificationMsg(t(`PR assigned to yourself Successfully`));
      }

      handleFloatRFQFORApprovedDirectActionField(id);

      setReload(!reload);
      setLoading(false);
    } catch (error) {
      console.error("Error updating assignee:", error);
    }
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "category_tree_name" && sortOrder === "ascend") {
      sortingEnumKey = "category_tree_name";
    }
    if (sortField === "category_tree_name" && sortOrder === "descend") {
      sortingEnumKey = "-category_tree_name";
    }
    if (sortField === "pr_creator" && sortOrder === "ascend") {
      sortingEnumKey = "pr_creator";
    }
    if (sortField === "pr_creator" && sortOrder === "descend") {
      sortingEnumKey = "-pr_creator";
    }

    if (sortField === "pr_number" && sortOrder === "ascend") {
      sortingEnumKey = "pr_number";
    }
    if (sortField === "pr_number" && sortOrder === "descend") {
      sortingEnumKey = "-pr_number";
    }

    if (sortField === "pr_approval_date" && sortOrder === "ascend") {
      sortingEnumKey = "pr_approval_date";
    }
    if (sortField === "pr_approval_date" && sortOrder === "descend") {
      sortingEnumKey = "-pr_approval_date";
    }

    if (sortField === "total_amount" && sortOrder === "ascend") {
      sortingEnumKey = "total_amount";
    }
    if (sortField === "total_amount" && sortOrder === "descend") {
      sortingEnumKey = "-total_amount";
    }

    if (sortField === "rfqstatus" && sortOrder === "ascend") {
      sortingEnumKey = "rfqstatus";
    }
    if (sortField === "rfqstatus" && sortOrder === "descend") {
      sortingEnumKey = "-rfqstatus";
    }
    return sortingEnumKey;
  };

  const columns = [
    {
      title: "Category",
      dataIndex: "category_tree_name",
      key: "category_tree_name",
      sorter: true,
    },
    {
      title: "PR Creator",
      dataIndex: "pr_creator",
      key: "pr_creator",
      sorter: true,
    },
    {
      title: "PR Number",
      dataIndex: "pr_number",
      key: "pr_number",
      sorter: true,
      // width: 100,
    },
    {
      title: `Estimated PR Value (${currencySymbol})`,
      dataIndex: "total_amount",
      key: "total_amount",
      align: "right",
      // className: "column-right",
      sorter: true,
      width: 150,
      render: (value) => (
        <span>
          {currencySymbol}{" "}
          {value.toLocaleString("en-IN", { maximumFractionDigits: 0 })}
        </span>
      ),
    },
    // {
    //   title: "Assign to Buyer",
    //   width: "160px",
    //   dataIndex: "pr_assign_to_buyer",
    //   key: "pr_assign_to_buyer",
    //   render: (e, record) => {
    //     const me = e === companyUserName ? "me" : e;

    //     return (
    //       <div>
    //         <Select
    //           value={me ? me : "Unassigned"}
    //           defaultValue={e}
    //           style={{ width: 120 }}
    //           onChange={(e) => handleAssignToBuyerChange(e, record, me)}
    //         >
    //           <Select.Option key="01" value="me">
    //             Assign to me
    //           </Select.Option>
    //           {/* {assignBuyer.map((option) => (
    //             <Select.Option key={option.user_id} value={option.user_id}>
    //               {option.first_name}
    //             </Select.Option>
    //           ))} */}
    //         </Select>
    //       </div>
    //     );
    //   },
    // },
    // selectedRow.length <= 1 &&
    {
      title: "Assign to Buyer",
      // width: "160px",
      dataIndex: "pr_assign_to_buyer",
      key: "pr_assign_to_buyer",
      render: (e, record) => {
        console.log("Record Name", e, record);
        const me = e === companyUserName ? "me" : e;

        return (
          <div>
            <Select
              value={me ? me : "Unassigned"}
              defaultValue={e}
              style={{ width: 120 }}
              onChange={(e) => handleAssignToBuyerChange(e, record, me)}
            >
              <Select.Option key="01" value="me">
                Assign to me
              </Select.Option>
              {assignBuyer.map((option) => (
                <Select.Option key={option.user_id} value={option.user_id}>
                  {option.first_name}
                </Select.Option>
              ))}
            </Select>
          </div>
        );
      },
    },
    {
      title: "RFQ Status",
      dataIndex: "pr_status_for_rfq",
      key: "pr_status_for_rfq",
      sorter: true,
    },

    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (record) => {
        console.log("recordcx", record);

        return (
          <Space>
            <Tooltip title="View PR">
              <Link
                to={`/purchase-requisition-assign-details/${record.id}/${id}`}
              >
                <EyeOutlined />
              </Link>
            </Tooltip>
            <Tooltip title="Float RFQ" placement="left">
              <img
                src={Floating}
                alt="SearchIcon"
                className="SearchIcon"
                width={22}
                onClick={() => handleFloatRFQ([record.id])}
                style={{ cursor: "pointer" }}
              />
            </Tooltip>
            <Tooltip title="Download Excel">
              <FileExcelOutlined
                onClick={() => handleExcelDownload(record.id, record.pr_number)}
              />
            </Tooltip>
            <Tooltip title="Download PDF">
              {record.category_tree_name.toLowerCase().includes("steel") ? (
                <DownloadOutlined
                  onClick={() =>
                    handleDownloadForSteel(record.id, record.pr_number)
                  }
                />
              ) : (
                <DownloadOutlined
                  onClick={() => handleDownload(record.id, record.pr_number)}
                />
              )}
            </Tooltip>
          </Space>
        );
      },
    },
  ].filter(Boolean);
  const renderAssignToBuyer = (e, record, id = "") => {
    const me = e === companyUserName ? "me" : e;
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    return (
      <div>
        <Select
          value={me ? me : "Unassigned"}
          defaultValue={e}
          style={{ width: 120 }}
          onChange={(value) => handleAssignToBuyerChange(value, record, me)} // Trigger modal on change
        >
          <Select.Option key="01" value="me">
            Assign to me
          </Select.Option>
          {/* Optionally add other assign buyers */}
        </Select>
      </div>
    );
  };

  // const handleAssigntoBuyer = async (id = "", record, value, name) => {
  //   let ids = selectedRow;
  //   if (ids.length === 0) {
  //     ids.push(id);
  //   }
  //   renderAssignToBuyer()
  //   console.log(id, selectedRow, "iddddd")
  //   // if (value === "me") {
  //   //   confirmAlert({
  //   //     title: "Confirm",
  //   //     message:
  //   //       "Are you sure you want to assign the selected employee to assign PR ?",
  //   //     buttons: [
  //   //       {
  //   //         label: "Yes",
  //   //         onClick: () => saveAssignToBuyer(companyUserId, record.id, name),
  //   //       },
  //   //       {
  //   //         label: "No",
  //   //       },
  //   //       {
  //   //         label: "Assign & Float RFQ",
  //   //         onClick: () =>
  //   //           handleFloatRFQValueDirect(
  //   //             companyUserId,
  //   //             record.id,
  //   //             record.id,
  //   //             name
  //   //           ),
  //   //       },
  //   //     ],
  //   //   });
  //   // } else {
  //   //   confirmAlert({
  //   //     title: "Confirm",
  //   //     message:
  //   //       "Are you sure you want to assign the selected employee to assign PR ?",
  //   //     buttons: [
  //   //       {
  //   //         label: "Yes",
  //   //         onClick: () => saveAssignToBuyer(value, record.id),
  //   //       },
  //   //       {
  //   //         label: "No",
  //   //       },
  //   //       {
  //   //         label: "Assign & Float RFQ",
  //   //         onClick: () =>
  //   //           handleFloatRFQValueDirect(value, record.id, selectedRow),
  //   //       },
  //   //     ],
  //   //   });
  //   // }
  //   try {
  //     console.log("abc")
  //   } catch (error) {
  //     setState((prevState) => ({
  //       ...prevState,
  //       page: 1,
  //       search: "",
  //     }));
  //   }
  // };
  useEffect(() => {
    const getPurchaseRequisitionDetails = async () => {
      setLoading(true);
    const fields = [
          "id",
          "category_tree_name",
          "pr_number",
          "pr_status_for_rfq",
          "pr_assign_to_buyer",
          "total_amount",
          "pr_creator",
          // "pr_approval_date",
        ].join(",");
      try {
        const queryParams = new URLSearchParams({
          
          pr_status: "Approved",
          category_id: id,
          fields: fields,
          page: state.page,
          page_size: state.pagesize,
          ordering: state.ordering,
          ...(state.search && { search: state.search }),
          ...(state.pr_created_date__gte && {
            pr_created_date__gte: moment(state.pr_created_date__gte, "DD-MM-YY").format("YYYY-MM-DD"),
          }),
          ...(state.pr_created_date__lte && {
            pr_created_date__lte: moment(state.pr_created_date__lte, "DD-MM-YY").format("YYYY-MM-DD"),
          }),
        });
        let apiResponse;
    if (employee) {
          apiResponse = await getRequest(
            `purchase-requisition/${CompanyId}/pr-by-company-id/?${queryParams.toString()}`,
            state
          );
        } else {
          queryParams.append("pr_assign_employee", employeeID);
          apiResponse = await getRequest(
            `purchase-requisition/${CompanyId}/pr-by-company-id/?${queryParams.toString()}`,
            state
          );
        }
        if (apiResponse.data.results.data) {
          setPurchaseRequisitionFloatRFQAssignPR(apiResponse.data.results.data);
          setAssignTobuyer(apiResponse.data.results.data.pr_assign_to_buyer);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_purchase_requisition"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getPurchaseRequisitionDetails();
  }, [reload, CompanyId, state]);

  console.log(
    "purchaseRequisitionFloatRFQAssignPR",
    purchaseRequisitionFloatRFQAssignPR
  );

  // Parse CSV Data into Array of Objects
  function parseCSV(data) {
    const lines = data.trim().split("\n");
    const headers = lines[0].split(",");
    return lines.slice(1).map((line) => {
      const values = line.split(",");
      return headers.reduce((obj, header, index) => {
        obj[header.trim()] = values[index].trim();
        return obj;
      }, {});
    });
  }

  // const handleDownload = async (prNumber) => {
  //   try {
  //     const endpoint = `purchase-requisition/${prNumber}/download-single-pr-history-excel/`;
  //     const response = await getRequest(endpoint);

  //     if (response.data && Array.isArray(response.data.data)) {
  //       console.log("Response Data:", response.data.data); // Inspect Data Structure

  //       const pdfColumns = [
  //         "PR Number",
  //         "PR Created Date",
  //         "Material Type",
  //         "UoM.",
  //         "Qty.",
  //         "PR Status",
  //         "PR Status for RFQ",
  //         "PR Creator",
  //         "Site Name",
  //       ];

  //       const pdfRows = response.data.data.map((item) =>
  //         [
  //           item["Purchase Requisition Number"] || "",
  //           item["Purchase Requisition Created Date"]
  //             ? moment(item["Purchase Requisition Created Date"]).format(
  //                 "DD-MM-YYYY HH:mm"
  //               )
  //             : "",
  //           item["Material Type by Company"] || "",
  //           item["Unit of Measurement"] || "",
  //           item["Total Quantity"] !== undefined
  //             ? Number(item["Total Quantity"]).toLocaleString("en-IN")
  //             : "0",
  //           item["Purchase Requisition Status"] || "",
  //           item["PR Status for RFQ"] || "",
  //           item["PR Creator"] || "",
  //           item["Site Name"] || "",
  //         ].map((value) =>
  //           typeof value === "object" ? JSON.stringify(value) : value
  //         )
  //       ); // Flatten Objects

  //       const pdf = new jsPDF("p", "pt", "a4");
  //       pdf.text(210, 40, "Purchase Requisition Details");

  //       pdf.autoTable({
  //         head: [pdfColumns],
  //         body: pdfRows,
  //         startY: 65,
  //         theme: "grid",
  //         styles: {
  //           font: "times",
  //           halign: "center",
  //           cellPadding: 3.5,
  //           textColor: [0, 0, 0],
  //         },
  //         headStyles: { fillColor: [9, 78, 143], textColor: [255, 255, 255] },
  //       });

  //       pdf.save(`purchase_requisition_${prNumber}_${+new Date()}.pdf`);
  //     } else {
  //       console.error("Invalid data format:", response.data);
  //       ErrorNotificationMsg("Invalid data format received.");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     ErrorNotificationMsg("Error downloading PR");
  //   }
  // };

  const handleDownload = async (prNumber, pr) => {
    try {
      const endpoint = `purchase-requisition/${prNumber}/download-single-pr-history-excel/`;
      const response = await getRequest(endpoint);

      if (!response?.data?.data) {
        console.error("No data received from API");
        return;
      }

      const parsedData = Array.isArray(response.data.data)
        ? response.data.data
        : [];
      const parsedData1 = Array.isArray(response.data.approval_by_site)
        ? response.data.approval_by_site
        : [];
      if (!parsedData.length) {
        console.error("No valid data to generate PDF.");
        return;
      }

      const pdf = new jsPDF("p", "pt", "a4");

      // Set full-page background color
      pdf.setFillColor(255, 255, 255); // Light gray
      pdf.rect(
        0,
        0,
        pdf.internal.pageSize.width,
        pdf.internal.pageSize.height,
        "F"
      );

      pdf.setFont("times");
      pdf.setFontSize(14);
      pdf.text("Purchase Requisition Report", 200, 40);

      // Extract PR Created Date from API response
      const prCreatedDate = parsedData1[0]?.pr_created_date || "N/A";

      // PR Number Text
      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(12);
      pdf.text(`PR Number: ${pr}`, 50, 75);

      // Get page width
      const pageWidth = pdf.internal.pageSize.width;

      // Set text properties
      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(12);

      // Calculate right-aligned position
      const textWidth = pdf.getTextWidth(`PR Created Date: ${prCreatedDate}`);
      pdf.text(
        `PR Created Date: ${prCreatedDate}`,
        pageWidth - textWidth - 50,
        75
      );

      // Material Table
      const materialColumns = [
        "Sr. No.",
        "City",
        "Site",
        "Item",
        "Quantity",
        "Preferred UoM.",
        "Qty. in Kg",
        "Est. Amount",
      ];
      const materialRows = [];
      let grandTotal = 0; // Grand total for all sites
      let serialNumber = 1; // Serial number counter

      parsedData.forEach((data) => {
        console.log("data", data);

        data.site_wise_pr.forEach((site, siteIndex) => {
          let siteTotal = 0; // Subtotal for the current site

          site.pr_material_details.forEach((item, index) => {
            console.log("itemddd", item);
            const estimatedAmount =
              item.pr_material_type_quantity_by_kg !== 0
                ? item.estimated_material_unit_price *
                  item.pr_material_type_quantity_by_kg
                : item.estimated_material_unit_price *
                    item.pr_material_type_quantity || 0;
            siteTotal += estimatedAmount;
            grandTotal += estimatedAmount;

            materialRows.push([
              siteIndex === 0 && index === 0 ? serialNumber++ : "", // Increment serial number
              siteIndex === 0 && index === 0 ? data.city_name : "", // Show city name only once
              index === 0 ? site.site_name : "", // Show site name only once
              item.pr_material_type_name,
              item.pr_material_type_quantity?.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              }),
              item.pr_material_type_uom_id === "Cubic Meter"
                ? "Cu. Mtr."
                : item.pr_material_type_uom_id,
              item.pr_material_type_quantity_by_kg?.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              }),
              `${estimatedAmount?.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              })}`,
            ]);
          });

          // Subtotal Row for each site (No background color, black text)
          materialRows.push([
            "", // Empty Sr. No.
            "", // Empty City
            {
              content: `Sub Total for ${site.site_name}`,
              colSpan: 5,
              styles: { halign: "right", fontStyle: "bold" },
            },
            {
              content: `${siteTotal?.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              })}`,
              styles: { fontStyle: "bold" },
            },
          ]);
        });
      });

      // Grand Total Row (Merged correctly)
      materialRows.push([
        "", // Empty Sr. No.
        "", // Empty City
        {
          content: "Total",
          colSpan: 5,
          styles: { halign: "right", fontStyle: "bold" },
        },
        {
          content: `${grandTotal?.toLocaleString("en-IN", {
            maximumFractionDigits: 0,
          })}`,
          styles: { fontStyle: "bold", halign: "right" },
        },
      ]);

      // Generate Table
      if (materialRows.length) {
        pdf.autoTable({
          head: [materialColumns],
          body: materialRows,
          startY: 100,
          theme: "grid",
          styles: {
            halign: "center",
            textColor: [0, 0, 0],
            fontSize: 10, // Adjust font size
            cellPadding: 5, // Proper spacing
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontStyle: "bold",
            lineWidth: 0.5,
          },
          columnStyles: {
            0: { cellWidth: 28 }, // Sr. No.
            1: { cellWidth: 65 }, // City
            2: { cellWidth: 70 }, // Site
            3: { cellWidth: 80 }, // Item
            4: { cellWidth: 50, halign: "right" }, // Quantity
            5: { cellWidth: 70 }, // Preferred UoM
            6: { cellWidth: 60, halign: "right" }, // Qty. in Kg
            7: { cellWidth: 90, halign: "right" }, // Est. Amount
          },
        });
      } else {
        pdf.text("No material data available.", 40, 120);
      }

      // Add PR Approval Status Title
      pdf.setFont("times", "bold");
      pdf.setFontSize(14);
      pdf.text("PR Approval Status:", 40, pdf.autoTable.previous.finalY + 35); // Add some space before table

      // Approval Table Headers
      const approvalColumns = [
        "City",
        "Site",
        "Approver",
        "Role",
        "Status",
        "Sent For Approval",
        "Approved Date",
        "Approval Time",
      ];
      console.log("parsedData", parsedData);

      const approvalRows = parsedData1.map((data) => [
        data.city_name || "N/A",
        data.site_name || "N/A",
        data.pr_approval_by || "N/A",
        (Array.isArray(data.pr_approval_by_role)
          ? data.pr_approval_by_role.map((role) => role.role_name)
          : ["N/A"]
        ).join(", "),
        data.pr_status || "Pending",
        data.pr_sent_for_approval_date || "-",
        data.pr_approval_date || "-",
        data.approval_time || "-",
      ]);

      // Generate Approval Table if Data Exists
      if (approvalRows.length) {
        pdf.autoTable({
          head: [approvalColumns],
          body: approvalRows,
          startY: pdf.autoTable.previous.finalY + 50,
          theme: "grid", // Adds visible borders
          styles: {
            halign: "center",
            fontSize: 10,
            cellPadding: 6, // Adds padding for better spacing
            textColor: [0, 0, 0],
            lineWidth: 0.5, // Keeps table borders visible
          },
          headStyles: {
            fillColor: [255, 255, 255], // White background (removes color)
            textColor: [0, 0, 0], // Black text
            fontStyle: "bold",
            lineWidth: 0.5, // Keeps header border
          },
          alternateRowStyles: { fillColor: [255, 255, 255] }, // No row colors (white background)
          columnStyles: {
            0: { cellWidth: 70 }, // Adjust column width
            1: { cellWidth: 80 },
            2: { cellWidth: 80, halign: "right" },
          },
        });
      } else {
        pdf.text(
          "No approval data available.",
          40,
          pdf.autoTable.previous.finalY + 50
        );
      }

      // Add Page Numbers
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.text(
          `Page ${i} of ${totalPages}`,
          pdf.internal.pageSize.width - 80,
          pdf.internal.pageSize.height - 30
        );
      }

      pdf.save(`purchase_requisition_${pr}.pdf`);
    } catch (error) {
      console.error("Error downloading PR:", error);
    }
  };

  const handleDownloadForSteel = async (prNumber, pr) => {
    try {
      const endpoint = `purchase-requisition/${prNumber}/download-single-pr-history-excel/`;
      const response = await getRequest(endpoint);

      if (!response?.data?.data) {
        console.error("No data received from API");
        return;
      }

      const parsedData = Array.isArray(response.data.data)
        ? response.data.data
        : [];
      const parsedData1 = Array.isArray(response.data.approval_by_site)
        ? response.data.approval_by_site
        : [];

      if (!parsedData.length) {
        console.error("No valid data to generate PDF.");
        return;
      }

      const pdf = new jsPDF("landscape", "pt", "a4");
      const pageWidth = pdf.internal.pageSize.width;

      // PDF Title
      pdf.setFillColor(255, 255, 255);
      pdf.rect(0, 0, pageWidth, pdf.internal.pageSize.height, "F");
      pdf.setFont("times");
      pdf.setFontSize(14);
      pdf.text("Purchase Requisition Report", pageWidth / 2 - 100, 40);

      const prCreatedDate = parsedData1[0]?.pr_created_date || "N/A";
      pdf.setFontSize(12);
      pdf.setTextColor(0, 0, 0);
      pdf.text(`PR Number: ${pr}`, 50, 75);
      const textWidth = pdf.getTextWidth(`PR Created Date: ${prCreatedDate}`);
      pdf.text(
        `PR Created Date: ${prCreatedDate}`,
        pageWidth - textWidth - 50,
        75
      );

      // === Capitalize diameter labels ===
      const allDiameters = new Set();
      parsedData.forEach((data) => {
        data.site_wise_pr?.forEach((site) => {
          site.pr_material_details?.forEach((item) => {
            item.steel_sizes?.forEach((size) => {
              const value = `${size.value}${(
                size.diameter_uom || ""
              ).toUpperCase()}`;
              allDiameters.add(value);
            });
          });
        });
      });

      const sortedDiameters = Array.from(allDiameters).sort(
        (a, b) => parseInt(a) - parseInt(b)
      );

      const materialColumns = [
        "Sr. No.",
        "City",
        "Site",
        "Grade & Quality",
        ...sortedDiameters,
        "Preferred UoM.",
        "Qty. in Kg",
        "Est. Amount",
      ];

      const materialRows = [];
      let grandTotal = 0;
      let serialNumber = 1;

      parsedData.forEach((data) => {
        data.site_wise_pr?.forEach((site, siteIndex) => {
          let siteTotal = 0;

          site.pr_material_details?.forEach((item, index) => {
            const estimatedAmount =
              item.pr_material_type_quantity_by_kg !== 0
                ? item.estimated_material_unit_price *
                  item.pr_material_type_quantity_by_kg
                : item.estimated_material_unit_price *
                    item.pr_material_type_quantity || 0;

            siteTotal += estimatedAmount;
            grandTotal += estimatedAmount;

            const diameterMap = {};
            item.steel_sizes?.forEach((size) => {
              const key = `${size.value}${(
                size.diameter_uom || ""
              ).toUpperCase()}`;
              diameterMap[key] = (diameterMap[key] || 0) + size.quantity;
            });

            const diameterQuantities = sortedDiameters.map(
              (dia) => diameterMap[dia]?.toLocaleString("en-IN") || "N/A"
            );

            materialRows.push([
              siteIndex === 0 && index === 0 ? serialNumber++ : "",
              siteIndex === 0 && index === 0 ? data.city_name : "",
              index === 0 ? site.site_name : "",
              item.pr_material_type_name || "-",
              ...diameterQuantities,
              item.pr_material_type_uom_id === "Cubic Meter"
                ? "Cu. Mtr."
                : item.pr_material_type_uom_id,
              item.pr_material_type_quantity_by_kg?.toLocaleString("en-IN") ||
                "0",
              estimatedAmount.toLocaleString("en-IN"),
            ]);
          });

          materialRows.push([
            "",
            "",
            {
              content: `Sub Total for ${site.site_name}`,
              colSpan: 4 + sortedDiameters.length,
              styles: { halign: "right", fontStyle: "bold" },
            },
            {
              content: `${siteTotal.toLocaleString("en-IN")}`,
              styles: { fontStyle: "bold", halign: "right" },
            },
            "",
            "",
          ]);
        });
      });

      materialRows.push([
        "",
        "",
        {
          content: "Total",
          colSpan: 4 + sortedDiameters.length,
          styles: { halign: "right", fontStyle: "bold" },
        },
        {
          content: `${grandTotal.toLocaleString("en-IN")}`,
          styles: { fontStyle: "bold", halign: "right" },
        },
        "",
        "",
      ]);

      // === Dynamic Column Widths ===
      let materialTableY = 100;
      let tableEndY = materialTableY;
      const totalColumns = materialColumns.length;
      const leftRightMargin = 40;
      const usableWidth = pageWidth - leftRightMargin * 2;
      const dynamicColWidth = Math.floor(usableWidth / totalColumns);

      const columnStyles = {};
      for (let i = 0; i < totalColumns; i++) {
        columnStyles[i] = { cellWidth: dynamicColWidth };
      }

      // === Generate Table ===
      if (materialRows.length) {
        pdf.autoTable({
          head: [materialColumns],
          body: materialRows,
          startY: materialTableY,
          theme: "grid",
          styles: {
            fontSize: 9,
            halign: "center",
            textColor: [0, 0, 0],
            cellPadding: 3,
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontStyle: "bold",
            lineWidth: 0.5,
          },
          columnStyles,
          didDrawPage: function (data) {
            tableEndY = data.cursor.y;
          },
        });
      } else {
        pdf.text("No material data available.", 40, materialTableY + 20);
      }

      // === PR Approval Table ===
      pdf.setFont("times", "bold");
      pdf.setFontSize(14);
      pdf.text("PR Approval Status:", 40, tableEndY + 30);

      const approvalColumns = [
        "City",
        "Site",
        "Approver",
        "Role",
        "Status",
        "Sent For Approval",
        "Approved Date",
        "Approval Time",
      ];

      const approvalRows = parsedData1.map((data) => [
        data.city_name || "N/A",
        data.site_name || "N/A",
        data.pr_approval_by || "N/A",
        (Array.isArray(data.pr_approval_by_role)
          ? data.pr_approval_by_role.map((role) => role.role_name)
          : ["N/A"]
        ).join(", "),
        data.pr_status || "Pending",
        data.pr_sent_for_approval_date || "-",
        data.pr_approval_date || "-",
        data.approval_time || "-",
      ]);

      if (approvalRows.length) {
        pdf.autoTable({
          head: [approvalColumns],
          body: approvalRows,
          startY: tableEndY + 45,
          theme: "grid",
          styles: {
            fontSize: 9,
            halign: "center",
            textColor: [0, 0, 0],
            cellPadding: 4,
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontStyle: "bold",
            lineWidth: 0.5,
          },
          alternateRowStyles: {
            fillColor: [255, 255, 255],
          },
        });
      } else {
        pdf.text("No approval data available.", 40, tableEndY + 50);
      }

      // === Footer with Page Numbers ===
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.setTextColor(100);
        pdf.text(
          `Page ${i} of ${totalPages}`,
          pdf.internal.pageSize.width - 80,
          pdf.internal.pageSize.height - 30
        );
      }

      pdf.save(`purchase_requisition_${pr}.pdf`);
    } catch (error) {
      console.error("Error downloading PR:", error);
    }
  };

  const handleExcelDownload = async (prNumber, pr) => {
    try {
      const endpoint = `purchase-requisition/${prNumber}/download-single-pr-history-excel/`;
      const response = await getRequest(endpoint);

      console.log("API Response:", response.data.data);
      const jsonData = response.data.data;

      // Determine category (assume first material's category_tree_name is representative)
      let categoryName = "";
      if (jsonData.length > 0 && jsonData[0].site_wise_pr.length > 0 && jsonData[0].site_wise_pr[0].pr_material_details.length > 0) {
        categoryName = jsonData[0].site_wise_pr[0].pr_material_details[0].category_tree_name || "";
      }

      let formattedData = [];
      let worksheet;
      let columnWidths;
      if (categoryName.toLowerCase() === "cement") {
        // Cement: Use current logic
        jsonData.forEach((city) => {
          let cityTotal = 0;
          let lastCity = null;
          city.site_wise_pr.forEach((site) => {
            let siteTotal = 0;
            let lastSite = null;
            site.pr_material_details.forEach((material, idx) => {
              const totalAmount =
                material.pr_material_type_quantity_by_kg === 0
                  ? material.pr_material_type_quantity * material.estimated_material_unit_price
                  : material.pr_material_type_quantity_by_kg * material.estimated_material_unit_price;

              // Only show city name if it's the first site/material of the city
              // Only show site name if it's the first material of the site
              const showCity = lastCity !== city.city_name;
              const showSite = lastSite !== site.site_name;
              formattedData.push({
                City: showCity ? city.city_name : "",
                Site: showSite ? site.site_name : "",
                "Material Name": material.pr_material_type_name,
                "Sub-Category":
                  material.pr_material_type_sub_category === "SPECIAL CEMENT"
                    ? "Special Cement"
                    : material.pr_material_type_sub_category,
                "UoM.":
                  material.pr_material_type_uom_id === "Cubic Meter"
                    ? "Cu. Mtr."
                    : material.pr_material_type_uom_id,
                "Qty.": material.pr_material_type_quantity,
                "Qty. in (Kg)": material.pr_material_type_quantity_by_kg,
                "Unit Price": material.estimated_material_unit_price,
                "Total Amount": totalAmount,
                Remarks: material.remark || "N/A",
              });
              lastCity = city.city_name;
              lastSite = site.site_name;
              siteTotal += totalAmount;
              cityTotal += totalAmount;
            });

            // Add site subtotal row
            formattedData.push({
              City: "",
              Site: `Sub Total for ${site.site_name}`,
              "Material Name": "",
              "Sub-Category": "",
              "UoM.": "",
              "Qty.": "",
              "Qty. in (Kg)": "",
              "Unit Price": "",
              "Total Amount": siteTotal,
              Remarks: "",
            });
          });

          // Add city total row
          formattedData.push({
            City: "",
            Site: `City Total for ${city.city_name}`,
            "Material Name": "",
            "Sub-Category": "",
            "UoM.": "",
            "Qty.": "",
            "Qty. in (Kg)": "",
            "Unit Price": "",
            "Total Amount": cityTotal,
            Remarks: "",
          });
        });

        worksheet = XLSX.utils.json_to_sheet(formattedData);
        columnWidths = [
          { wch: 15 }, // City
          { wch: 25 }, // Site (wider for subtotal/city total labels)
          { wch: 15 }, // Material Name
          { wch: 18 }, // Sub-Category
          { wch: 10 }, // Unit of Measure
          { wch: 5 }, // Quantity
          { wch: 12 }, // Quantity (Kg)
          { wch: 12 }, // Unit Price
          { wch: 15 }, // Total Amount (wider for totals)
          { wch: 15 }, // Remarks
        ];
      } else {
        // Not Cement: Show diameter-wise columns
        // 1. Collect all unique diameters
        const allDiameters = new Set();
        jsonData.forEach(city => {
          city.site_wise_pr.forEach(site => {
            site.pr_material_details.forEach(material => {
              (material.steel_sizes || []).forEach(size => {
                allDiameters.add(`${size.value}${size.diameter_uom || ""}`);
              });
            });
          });
        });
        const sortedDiameters = Array.from(allDiameters).sort((a, b) => parseInt(a) - parseInt(b));

        // 2. Build rows
        jsonData.forEach((city) => {
          let cityTotal = 0;
          let lastCity = null;
          city.site_wise_pr.forEach((site) => {
            let siteTotal = 0;
            let lastSite = null;
            site.pr_material_details.forEach((material, idx) => {
              const totalAmount =
                material.pr_material_type_quantity_by_kg === 0
                  ? material.pr_material_type_quantity * material.estimated_material_unit_price
                  : material.pr_material_type_quantity_by_kg * material.estimated_material_unit_price;

              // Only show city name if it's the first site/material of the city
              // Only show site name if it's the first material of the site
              const showCity = lastCity !== city.city_name;
              const showSite = lastSite !== site.site_name;
              const row = {
                City: showCity ? city.city_name : "",
                Site: showSite ? site.site_name : "",
                "Grade & Quality": material.pr_material_type_name || "",
              };
              // Fill diameter columns
              sortedDiameters.forEach(dia => {
                // Find the size for this diameter
                const found = (material.steel_sizes || []).find(size => `${size.value}${size.diameter_uom || ""}` === dia);
                row[dia] = found ? found.quantity : "";
              });
              row["Qty. in Kg"] = material.pr_material_type_quantity_by_kg;
              row["UoM."] =
                material.pr_material_type_uom_id === "Cubic Meter"
                  ? "Cu. Mtr."
                  : material.pr_material_type_uom_id;
              row["Est. Amount"] = totalAmount;
              formattedData.push(row);
              lastCity = city.city_name;
              lastSite = site.site_name;
              siteTotal += totalAmount;
              cityTotal += totalAmount;
            });
            // Add site subtotal row
            const subtotalRow = {
              City: "",
              Site: `Sub Total for ${site.site_name}`,
              "Grade & Quality": "",
            };
            sortedDiameters.forEach(dia => {
              subtotalRow[dia] = "";
            });
            subtotalRow["Qty. in Kg"] = "";
            subtotalRow["UoM."] = "";
            subtotalRow["Est. Amount"] = siteTotal;
            formattedData.push(subtotalRow);
          });
          // Add city total row
          const cityTotalRow = {
            City: "",
            Site: `City Total for ${city.city_name}`,
            "Grade & Quality": "",
          };
          sortedDiameters.forEach(dia => {
            cityTotalRow[dia] = "";
          });
          cityTotalRow["Qty. in Kg"] = "";
          cityTotalRow["UoM."] = "";
          cityTotalRow["Est. Amount"] = cityTotal;
          formattedData.push(cityTotalRow);
        });
        // Build columns for worksheet
        const baseCols = [
          { wch: 15 }, // City
          { wch: 25 }, // Site
          { wch: 20 }, // Grade & Quality
        ];
        const diaCols = sortedDiameters.map(() => ({ wch: 10 }));
        const restCols = [
          { wch: 12 }, // Qty in Kg
          { wch: 10 }, // UoM
          { wch: 15 }, // Est. Amount
        ];
        columnWidths = [...baseCols, ...diaCols, ...restCols];
        worksheet = XLSX.utils.json_to_sheet(formattedData);
      }

      worksheet["!cols"] = columnWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Purchase Requisition");

      // **Trigger File Download**
      XLSX.writeFile(workbook, `Purchase_Requisition_${pr}.xlsx`);
    } catch (error) {
      console.error("Download Error:", error);
      ErrorNotificationMsg("Error downloading PR");
    }
  };

  // Function to convert JSON to CSV
  const convertJSONToCSV = (jsonData) => {
    if (!Array.isArray(jsonData) || jsonData.length === 0) return "";

    const headers = Object.keys(jsonData[0]).join(",");
    const rows = jsonData.map((row) =>
      Object.values(row)
        .map((value) =>
          typeof value === "object" ? JSON.stringify(value) : value
        )
        .join(",")
    );

    return [headers, ...rows].join("\n");
  };

  // const handleAssignToBuyerChange = async (value, record, name) => {
  //   let ids = selectedRow;
  //   if (ids.length === 0) {
  //     ids.push(id);
  //   }
  //   if (value === "me") {
  //     confirmAlert({
  //       title: "Confirm",
  //       message:
  //         "Are you sure you want to assign the selected employee to assign PR ?",
  //       buttons: [
  //         {
  //           label: "Yes",
  //           onClick: () => saveAssignToBuyer(companyUserId, id, name),
  //         },
  //         {
  //           label: "No",
  //         },
  //         {
  //           label: "Assign & Float RFQ",
  //           onClick: () =>
  //             handleFloatRFQValueDirect(
  //               companyUserId,
  //               record.id,
  //               id,
  //               record.id,
  //               name
  //             ),
  //         },
  //       ],
  //     });
  //   } else {
  //     confirmAlert({
  //       title: "Confirm",
  //       message:
  //         "Are you sure you want to assign the selected employee to assign PR ?",
  //       buttons: [
  //         {
  //           label: "Yes",
  //           onClick: () => saveAssignToBuyer(value, record.id, id),
  //         },
  //         {
  //           label: "No",
  //         },
  //         {
  //           label: "Assign & Float RFQ",
  //           onClick: () =>
  //             handleFloatRFQValueDirect(value, record.id, selectedRow, id),
  //         },
  //       ],
  //     });
  //   }
  // };
  // const handleAssignToBuyerChangeModal = async (value, record, name, id = "") => {
  //   let ids = selectedRow;
  //   if (ids.length === 0) {
  //     ids.push(id);
  //   }
  //   setIsModalVisible(false); // Close modal when cancel is clicked

  //   console.log(selectedRow, "rddd")
  //   if (value === "me") {
  //     confirmAlert({
  //       title: "Confirm",
  //       message:
  //         "Are you sure you want to assign the selected employee to assign PR ?",
  //       buttons: [
  //         {
  //           label: "Yes",
  //           // onClick: () => saveAssignToBuyerModal(companyUserId, record.id, name, id),
  //           onClick: () => saveAssignToBuyerModal(companyUserId, ids, name),

  //         },
  //         {
  //           label: "No",
  //         },
  //         {
  //           label: "Assign & Float RFQ",
  //           onClick: () =>
  //             handleFloatRFQValueDirect(
  //               companyUserId,
  //               record.id,
  //               record.id,
  //               id,
  //               name
  //             ),
  //         },
  //       ],
  //     });
  //   } else {
  //     confirmAlert({
  //       title: "Confirm",
  //       message:
  //         "Are you sure you want to assign the selected employee to assign PR ?",
  //       buttons: [
  //         {
  //           label: "Yes",
  //           onClick: () => saveAssignToBuyerModal(value, ids),
  //         },
  //         {
  //           label: "No",
  //         },
  //         {
  //           label: "Assign & Float RFQ",
  //           onClick: () =>
  //             handleFloatRFQValueDirect(value, record.id, selectedRow, id),
  //         },
  //       ],
  //     });
  //   }
  // };

  // const handleAssignToBuyerChange = async (value, record, name) => {
  //   if (value === "me") {
  //     confirmAlert({
  //       title: "Confirm",
  //       message:
  //         "Are you sure you want to assign the selected employee to assign PR ?",
  //       buttons: [
  //         {
  //           label: "Yes",
  //           onClick: () => saveAssignToBuyer(companyUserId, record.id, name),
  //         },
  //         {
  //           label: "No",
  //         },
  //         {
  //           label: "Assign & Float RFQ",
  //           onClick: () =>
  //             handleFloatRFQValueDirect(
  //               companyUserId,
  //               record.id,
  //               record.id,
  //               name
  //             ),
  //         },
  //       ],
  //     });
  //   } else {
  //     confirmAlert({
  //       title: "Confirm",
  //       message:
  //         "Are you sure you want to assign the selected employee to assign PR ?",
  //       buttons: [
  //         {
  //           label: "Yes",
  //           onClick: () => saveAssignToBuyer(value, record.id),
  //         },
  //         {
  //           label: "No",
  //         },
  //         {
  //           label: "Assign & Float RFQ",
  //           onClick: () =>
  //             handleFloatRFQValueDirect(value, record.id, selectedRow),
  //         },
  //       ],
  //     });
  //   }
  // };
  // Function to retrieve buyer name from user_id
  const getBuyerName = (id) => {
    const buyer = assignBuyer.find((buyer) => buyer.user_id === id);
    return buyer ? buyer.first_name : "Unassigned";
  };
  const handleAssignToBuyerChange = async (value, record, name) => {
    let buyerName = value !== "me" ? getBuyerName(value) : "yourself";

    confirmAlert({
      title: "Confirm",
      // message: `Are you sure you want to assign ${buyerName} to assign PR?`,
      // message: `Are you sure you want to assign ${buyerName} to handle the PR?`,
      message: (
        <>
          <b>
            Are you sure you want to assign <strong>{buyerName}</strong> to
            handle the PR?
          </b>
        </>
      ),
      buttons: [
        {
          label: "Yes",
          onClick: () =>
            saveAssignToBuyer(
              value === "me" ? companyUserId : value,
              record.id,
              name
            ),
          style: {
            backgroundColor: "#094e8f",
            color: "white",
            padding: "10px 18px",
            border: "none",
            borderRadius: "4px",
            fontSize: "16px",
          },
        },
        {
          label: "No",
          style: {
            backgroundColor: "#F1F1F1",
            color: "black",
            padding: "10px 18px",
            border: "none",
            borderRadius: "4px",
            fontSize: "16px",
          },
        },
        {
          label: "Assign & Float RFQ",
          onClick: () =>
            handleFloatRFQValueDirect(
              value === "me" ? companyUserId : value,
              record.id,
              value === "me" ? record.id : selectedRow,
              name
            ),
          style: {
            backgroundColor: "#094e8f",
            color: "white",
            padding: "10px 18px",
            border: "none",
            borderRadius: "4px",
            fontSize: "16px",
          },
        },
      ],
    });
  };

  const handleAssignToBuyerChangeModal = async (
    value,
    record,
    name,
    id = ""
  ) => {
    let ids = [...selectedRow]; // Use the selected rows
    if (ids.length === 0 && id) {
      ids.push(id); // Add the provided `id` if no rows are selected
    }

    console.log("Selected IDs:", ids);

    if (value === "me") {
      confirmAlert({
        title: "Confirm",
        message:
          "Are you sure you want to assign the selected employee to assign PR?",
        buttons: [
          {
            label: "Yes",
            onClick: () =>
              saveAssignToBuyerModalNames(companyUserId, ids, name),
            style: {
              backgroundColor: "#094e8f",
              color: "white",
              padding: "10px 18px",
              border: "none",
              borderRadius: "4px",
              fontSize: "16px",
            },
          },
          {
            label: "No",
            style: {
              backgroundColor: "#F1F1F1",
              color: "black",
              padding: "10px 18px",
              border: "none",
              borderRadius: "4px",
              fontSize: "16px",
            },
          },
          {
            label: "Assign & Float RFQ",
            onClick: () =>
              handleMultipleFloatRFQValueDirect(
                companyUserId,
                record.id,
                selectedRow,
                id,
                name
              ),
            style: {
              backgroundColor: "#094e8f",
              color: "white",
              padding: "10px 18px",
              border: "none",
              borderRadius: "4px",
              fontSize: "16px",
            },
          },
        ],
      });
    } else {
      confirmAlert({
        title: "Confirm",
        message:
          "Are you sure you want to assign the selected employee to assign PR?",
        buttons: [
          {
            label: "Yes",
            onClick: () => saveAssignToBuyerModalNames(value, ids, name),
          },
          {
            label: "No",
          },
          {
            label: "Assign & Float RFQ",
            onClick: () =>
              handleMultipleFloatRFQValueDirect(
                value,
                record.id,
                selectedRow,
                id
              ),
          },
        ],
      });
    }
  };

  useEffect(() => {
    const getAssignBuyer = async () => {
      try {
        const response = await getRequest(
          `purchase-requisition/assign-to-buyer/`
        );
        setAssignBuyer(response.data.results.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    getAssignBuyer();
  }, [id]);

  // const saveAssignToBuyerModal = async (value, ids, name) => {
  //   try {
  //     await patchRequest(`purchase-requisition/pr-assign-to-buyer/`, {
  //       pr_assign_to_buyer: value,
  //       pr_ids: ids
  //     });
  //     // SuccessNotificationMsg(t("pr_assign_to_buyer_successfully"));

  //     if (value !== companyUserId) {
  //       let assignedEmployee = assignBuyer.find(
  //         (buyer) => buyer.user_id === value
  //       );
  //       SuccessNotificationMsg(
  //         t(`PR assigned to ${assignedEmployee.first_name} Successfully`)
  //       );
  //     } else {
  //       SuccessNotificationMsg(t(`PR assigned to yourself Successfully`));
  //     }

  //     setReload(!reload);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error updating assignee:", error);
  //   }
  // };

  const saveAssignToBuyerModalNames = async (value, name) => {
    let ids = [...selectedRow]; // Use the selected rows
    if (ids.length === 0 && id) {
      ids.push(id); // Add the provided `id` if no rows are selected
    }
    try {
      await patchRequest(`purchase-requisition/multiple-pr-assign-to-buyer/`, {
        pr_assign_to_buyer: value, // Assignee ID
        pr_ids: ids, // Pass multiple IDs as an array
      });
      // Success message handling
      if (value !== companyUserId) {
        let assignedEmployee = assignBuyer.find(
          (buyer) => buyer.user_id === value
        );
        setSelectedValue(assignedEmployee.first_name);
        SuccessNotificationMsg(
          t(`PR assigned to ${assignedEmployee.first_name} Successfully`)
        );
      } else {
        SuccessNotificationMsg(t(`PR assigned to yourself Successfully`));
      }

      setReload(!reload); // Trigger data reload
      setLoading(false);
    } catch (error) {
      console.error("Error updating assignee:", error);
    }
  };

  // const saveAssignToBuyer = async (value, id, name) => {
  //   try {
  //     await patchRequest(`purchase-requisition/${id}/pr-assign-to-buyer/`, {
  //       pr_assign_to_buyer: value,
  //     });
  //     // SuccessNotificationMsg(t("pr_assign_to_buyer_successfully"));

  //     if (value !== companyUserId) {
  //       let assignedEmployee = assignBuyer.find(
  //         (buyer) => buyer.user_id === value
  //       );
  //       SuccessNotificationMsg(
  //         t(`PR assigned to ${assignedEmployee.first_name} Successfully`)
  //       );
  //     } else {
  //       SuccessNotificationMsg(t(`PR assigned to yourself Successfully`));
  //     }

  //     setReload(!reload);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error updating assignee:", error);
  //   }
  // };
  console.log("selectedValue22", selectedValue);

  const saveAssignToBuyer = async (value, id, name) => {
    try {
      await patchRequest(`purchase-requisition/${id}/pr-assign-to-buyer/`, {
        pr_assign_to_buyer: value,
      });
      // SuccessNotificationMsg(t("pr_assign_to_buyer_successfully"));

      if (value !== companyUserId) {
        let assignedEmployee = assignBuyer.find(
          (buyer) => buyer.user_id === value
        );
        SuccessNotificationMsg(
          t(`PR assigned to ${assignedEmployee.first_name} Successfully`)
        );
      } else {
        SuccessNotificationMsg(t(`PR assigned to yourself Successfully`));
      }

      setReload(!reload);
      setLoading(false);
    } catch (error) {
      console.error("Error updating assignee:", error);
    }
  };

  const handleApplyFilter = () => {
    setClickedFilterButton(true);
    const filterParams = {
      pr_created_date__gte: startDate,
      pr_created_date__lte: endDate,
    };

    setState(filterParams);
  };

  const handlePdfDownload = async () => {
    const endpoint = `purchase-requisition/${CompanyId}/download-company-pr-approved-history-excel?pr_status=Approved&category_id=${id}`;
    const fileType = "csv";

    try {
      //setBtnloading(true);
      await getRequest(endpoint)
        .then((response) => {
          // const blob = new Blob([response.data], {
          //   type: "text/csv",
          // });
          // const link = document.createElement("a");
          // link.href = window.URL.createObjectURL(blob);
          // link.download = `purchase-requisition_${CompanyId}-${+new Date()}.${fileType}`;
          // link.click();

          /* PDF Download */
          // console.log(response.data);
          if (response.data) {
            const parsedData = parseCSV(response.data);
            // Define dynamic columns based on CSV headers
            const pdfColumns = [
              "PR Number",
              "PR Created Date",
              "Material Type by Company",
              "UOM",
              "Total Quantity",
              "PR status",
              "PR status for RFQ",
              "PR Creator",
              "Site name",
              // "Quantity",
            ];
            // Generate rows for jsPDF table directly from parsed data
            const pdfRows = parsedData.map((item) => [
              item["Purchase Requisition Number"],
              moment(item["Purchase Requisition Created Date"]).format(
                "DD-MM-YYYY HH:mm"
              ),
              item["Material Type by Company"],
              item["Unit of Measurement"],
              Number(item["Total Quantity"]).toLocaleString("en-IN", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
              }), // Removes decimal and trailing zeros
              item["Purchase Requisition status"],
              item["PR status for RFQ"],
              item["PR Creator"],
              item["Site name"],
              Number(item["Quantity"]).toLocaleString("en-IN", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
              }), // Same for Quantity
            ]);

            // PDF generation with jsPDF and autoTable
            const pdf = new jsPDF("p", "pt", "a4");
            pdf.text(210, 40, "Assign PR & Float RFQ");

            // Use autoTable to create a table with dynamic columns and rows
            pdf.autoTable(pdfColumns, pdfRows, {
              startY: 65,
              theme: "grid",
              styles: {
                font: "times",
                halign: "center",
                cellPadding: 3.5,
                lineWidth: 0.5,
                lineColor: [0, 0, 0],
                textColor: [0, 0, 0],
              },
              headStyles: {
                textColor: [255, 255, 255],
                fontStyle: "normal",
                lineWidth: 0.5,
                lineColor: [0, 0, 0],
                fillColor: [9, 78, 143],
              },
              alternateRowStyles: {
                fillColor: [212, 212, 212],
                textColor: [0, 0, 0],
                lineWidth: 0.5,
                lineColor: [0, 0, 0],
              },
              rowStyles: {
                lineWidth: 0.5,
                lineColor: [0, 0, 0],
              },
              tableLineColor: [0, 0, 0],
            });

            pdf.save(
              `purchase_requisition_summary_${CompanyId}_${+new Date()}`
            );
          }
        })
        .catch((error) => {
          // ErrorNotificationMsg(t(`err_${fileType}_download`));
        });
    } catch (error) {
      //setBtnloading(false);
      // ErrorNotificationMsg(error);
    }
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    if (value) {
      setState({
        ...state,
        search: value,
      });
    } else {
      const { search, ...newState } = state; // Remove 'search' key from state
      setState(newState);
    }
  };

  useEffect(() => {
    const getCurrency = async () => {
      try {
        const response = await getRequest(
          "business-settings/get-currency-by-business-setting/"
        );
        setCurrencySymbol(response.data.data);
      } catch (error) {
        console.error("Error fetching currency symbol:", error);
      }
    };

    getCurrency();
  }, []);

  const formatApprovalTime = (timeString) => {
    if (timeString === "0 Hrs 0 min 0 sec") {
      return "0 Hrs 0 min 0 sec";
    } else {
      const timeParts = timeString?.match(
        /(\d+)\s*days?,?\s*(\d+)\s*hours?,?\s*(\d+)\s*minutes?,?\s*(\d+)\s*seconds?/
      );

      if (!timeParts) return "";

      const [_, days, hours, minutes, seconds] = timeParts.map(Number);

      const formattedTime = `${hours ? hours + " hrs " : ""}${
        minutes ? minutes + " min " : ""
      }${seconds ? seconds + " sec" : ""}`;

      return formattedTime.trim();
    }
  };

  const handleChange = (value) => {};
  const expandedRowRender = (materialTypeName, index) => {
    const columns = [
      {
        title: "City ",
        dataIndex: "city_name",
        key: "city_name",
        // width: "150px",
      },
      {
        title: "Site",
        dataIndex: "site_name",
        key: "site_name",
        // width: "150px",
      },
      {
        title: "Approved By",
        dataIndex: "pr_approval_by",
        key: "pr_approval_by",
        // width: "150px",
      },
      {
        title: "Role",
        dataIndex: "role",
        key: "role",
        // width: 150,
        ellipsis: true,
        render: (text, record) => {
          const roleNames = record.pr_approval_by_role
            ?.filter((item) => item?.role_name)
            .map((item) => item.role_name)
            .join(", ");
          return (
            <div>
              <Tooltip color="#094E8F" title={roleNames} placement="topLeft">
                <span>{roleNames}</span>
              </Tooltip>
            </div>
          );
        },
      },
      {
        title: "Sent For Approval Date & Time",
        dataIndex: "pr_sent_for_approval_date",
        key: "pr_sent_for_approval_date",
        // width: "200px",
      },
      {
        title: "Approved Date & Time",
        dataIndex: "pr_approval_date",
        key: "pr_approval_date",
        // width: "230px",
      },
      {
        title: "Approval Time/Hrs",
        dataIndex: "approval_time",
        key: "approval_time",
        // width: "150px",
        render: (text) => formatApprovalTime(text),
      },
      {
        title: "Status",
        dataIndex: "pr_status",
        key: "pr_status",
      },
    ];

    return (
      <Table
        className="subtbl"
        columns={columns}
        dataSource={zoneList}
        pagination={false}
        style={{ marginTop: "5px" }}
      />
    );
  };

  const getZoneList = async (id) => {
    setLoading(true);
    try {
      let apiResponse = await getRequest(
        `purchase-requisition/${id}/get-pr-approval-data-by-site/`
      );
      if (apiResponse?.status) {
        setZoneList(apiResponse?.data?.data[0]?.approval_by_site || []);
      } else {
        ErrorNotificationMsg(t("error_in_company_address_list"));
      }
    } catch (error) {
      console.error("Error fetching approval data:", error);
    }
    setLoading(false);
  };

  const handleExpand = async (expanded, record) => {
    if (expanded) {
      await getZoneList(record.id);
      setExpandedRowKeys([record.id]);
    } else {
      setExpandedRowKeys([]);
    }
  };
  const [isModalVisible, setIsModalVisible] = useState(false); // State to manage modal visibility
  // const [selectedValue, setSelectedValue] = useState(null); // State for selected dropdown value
  // const selectRef = useRef(null); // Reference for the Select component

  // const handleAssignToBuyerClick = () => {
  //   <div>
  //     <Select
  //       ref={selectRef} // Attach the ref to the Select component
  //       value={selectedValue}
  //       style={{ width: 120 }}
  //       onChange={handleAssignToBuyerChangeModal}
  //       autoFocus // Optionally autofocus on dropdown when modal opens
  //     >
  //       <Select.Option value="me">Assign to me</Select.Option>
  //       {/* Add more options here */}
  //     </Select>
  //   </div>
  //   //setIsModalVisible(true); // Show the modal
  // };

  const handleModalCancel = () => {
    setIsModalVisible(false); // Close modal when cancel is clicked
  };

  // const handleAssignToBuyerChange = (value) => {
  //   setSelectedValue(value); // Handle select value change
  // };

  const openDropdown = () => {
    if (selectRef.current) {
      selectRef.current.focus(); // Programmatically open the dropdown when modal is shown
    }
  };

  const handleAssignToBuyerClick = () => {
    setIsDropdownVisible(!isDropdownVisible); // Toggle dropdown visibility
  };

  // const handleAssignToBuyerChangeModal = (value) => {
  //   setSelectedValue(value); // Update selected value
  //   console.log("Selected value:", value);
  //   setIsDropdownVisible(false); // Optionally hide dropdown after selection
  // };
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3> Assign PR & Float RFQ </h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/history">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/assign-pr">{t("Select Category for RFQ")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item> Assign PR & Float RFQ</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                {/* <Form form={form}>
                  <Form.Item name="search" initialValue=""> */}
                    <Search
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                      style={{
                        width: 250,
                      }}
                    />
                  {/* </Form.Item>
                </Form> */}
              </Space>
            </div>
          </Space>
        </div>
      </div>
      <section className="grid-sec mt-5">
        <SubscriptionNotification />
        <div className="PR-body">
          <div className="filterrow">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef}>
                <Space wrap>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item name="pr_created_date__gte">
                      <DatePicker
                        format="DD-MM-YY"
                        placeholder="Select Start Date"
                        value={startDate}
                        onChange={handleStartDateChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item name="pr_created_date__lte">
                      <DatePicker
                        format="DD-MM-YY"
                        placeholder="Select End Date"
                        value={endDate}
                        onChange={handleEndDateChange}
                      />
                    </Form.Item>
                  </Col>
                  <>
                    <Button
                      type="primary"
                      htmlType="Apply"
                      icon={
                        <Tooltip title="Apply" color="#094E8F">
                          <FilterOutlined style={{ fontSize: "20px" }} />
                        </Tooltip>
                      }
                      style={{
                        backgroundColor: "#094e8f",
                        color: "#ffffff",
                        border: "none",
                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                        width: "40px",
                        height: "40px",
                        borderRadius: "4px",
                      }}
                      onClick={startDate || endDate ? handleApplyFilter : null}
                    />
                    <Button
                      type="primary"
                      htmlType="Reset"
                      icon={
                        <Tooltip title="Reset" color="#094E8F">
                          <UndoOutlined style={{ fontSize: "20px" }} />
                        </Tooltip>
                      }
                      style={{
                        backgroundColor: "#094e8f",
                        color: "#ffffff",
                        border: "none",
                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                        width: "40px",
                        height: "40px",
                        borderRadius: "4px",
                      }}
                      onClick={
                        clickedFilterButton ? handleReset : handleClearFields
                      }
                    />
                  </>
                </Space>
              </Form>
            </div>
            <div className="btnscol">
              <Space>
                <div>
                  {/* {selectedRow.length > 0 && (
                    <Button
                      className="BlueShadowBtn"
                      type="primary"
                      htmlType="button"
                      onClick={handleAssignToBuyerClick}
                    >
                   Assign To Buyer
                   </Button>
                  )} */}

                  {selectedRow.length > 1 && (
                    <div>
                      <Select
                        ref={selectRef}
                        placeholder="Assign to buyer"
                        value={selectedValue}
                        style={{ width: 140 }}
                        onChange={handleAssignToBuyerChangeModal}
                        autoFocus
                      >
                        <Select.Option value="me">Assign to me</Select.Option>
                        {assignBuyer.map((option) => (
                          <Select.Option
                            key={option.user_id}
                            value={option.user_id}
                          >
                            {option.first_name}
                          </Select.Option>
                        ))}
                        {/* Add more options here */}
                      </Select>
                    </div>
                  )}
                </div>
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Refresh"
                  label="Refresh"
                  onClick={handleRefresh}
                  icon={<img src={RefreshIcon} alt="Refresh Icon" />}
                />
                {/* {endDate || startDate || prStatus ? (
                  <>
                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Apply"
                      label="Apply"
                      onClick={handleApplyFilter}
                    />
                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Reset"
                      label="Reset"
                      onClick={handleReset}
                    />
                  </>
                ) : (
                  ""
                )} */}

                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="button"
                  label="Float RFQ"
                  onClick={() => handleFloatRFQ(selectedRow)}
                  loading={btnLoading}
                />
                {/* <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="PDF"
                  label="PDF"
                  icon={<img src={ExelDownload} alt="PDF Icon" />}
                  onClick={handlePdfDownload}
                /> */}
                {/* {selectedRow.length > 0 && (
                  <ButtonField
                    className="BlueShadowBtn"
                    type="primary"
                    htmlType="button"
                    label={t("Assign To Buyer")}
                    //onClick={renderAssignToBuyer}
                    onClick={handleAssignToBuyerClick}
                  //onClick={() => renderAssignToBuyer()}
                  />
                )} */}

                {/* <Modal
                  title="Assign to Buyer"
                  visible={isModalVisible} // Show the modal when this state is true
                  onCancel={handleModalCancel} // Close modal on cancel
                  footer={null} // Customize footer as needed
                  afterClose={() => setSelectedValue(null)} // Reset selected value after modal is closed
                >
                  <p>Your modal content here...</p>
                  {/* Dropdown inside the modal */}

                {/* </Modal>  */}
              </Space>
            </div>
          </div>

          <Table
            columns={columns}
            dataSource={purchaseRequisitionFloatRFQAssignPR}
            rowKey={(record) => record.id}
            rowSelection={rowSelection}
            loading={loading || btnLoading}
            scroll={{ x: "auto" }}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            expandable={{
              expandedRowRender,
              onExpand: handleExpand,
              expandedRowKeys,
            }}
            onChange={handleTableChange}
          />

          <div className="btnwrp">
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="button"
              label="Float RFQ"
              onClick={() => handleFloatRFQ(selectedRow)}
              loading={btnLoading}
            />
          </div>
        </div>
      </section>
    </>
  );
};
export default AssignPurchaseRequisition;
